import * as React from "react";

import "./StreamPost.css";

const Waypoint = require("react-waypoint");

const LightBox = require("@navrin/react-image-lightbox");

import { Post } from "../../../schemas/Post";
import { ShortTag, TagCollection } from "../../../schemas/Tag";
import { observer, inject } from "mobx-react";
import { StreamInfo } from "../StreamInfo/StreamInfo";
import { observable } from "mobx";
import { StreamStore } from "../../../stores/StreamStore";
import * as MediaQuery from "react-responsive";

type ShortPost = Post<TagCollection<ShortTag>>;

interface StreamPostProps {
    post: ShortPost;
    id: number;
    position: number;
    active: boolean;
    onEnter: (i: number) => void;
}

// interface WaypointCallbackObject {
//     waypointTop: number;
//     view
// }

@inject((allStores) => ({
    streamStore: allStores.streamStore as StreamStore,
}))
@observer
class StreamPost extends React.Component<
    StreamPostProps & { streamStore?: StreamStore }
> {
    @observable previewOpen = false;
    postRef: HTMLDivElement;

    render() {
        const post = (
            <div
                data-id={this.props.id}
                // onScroll={this.onScroll}
                className="StreamPost"
            >
                {this.getPostType(this.props.post)}
                <StreamInfo
                    position={this.props.position}
                    active={this.props.active}
                    post={this.props.post}
                />
            </div>
        );

        return (
            <MediaQuery minWidth={1080}>
                {(matched: boolean) => {
                    if (matched) {
                        return (
                            <Waypoint
                                onEnter={() => {
                                    this.props.streamStore!.activePost =
                                        this.props.id;
                                    this.props.onEnter(this.props.id);
                                }}
                                topOffset="30%"
                                bottomOffset="40%"
                            >
                                {post}
                            </Waypoint>
                        );
                    } else {
                        return post;
                    }
                }}
            </MediaQuery>
        );
    }

    private getPostType(p: ShortPost): JSX.Element {
        if (p.file_ext === "swf") {
            return <div />; // todo: maybe? never? kill flash?
        }

        if (p.file_ext === "webm" || p.file_ext === "mp4") {
            return <video controls={true} src={p.file_url} />;
        }
        return (
            <div>
                {this.previewOpen && (
                    <LightBox
                        mainSrc={p.file_url}
                        onCloseRequest={() => (this.previewOpen = false)}
                        /* onClick={() => (this.previewOpen = false)} */
                    />
                )}
                <img
                    onClick={() => (this.previewOpen = true)}
                    src={p.file_url}
                />
            </div>
        );
    }
}

export { StreamPost };



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Stream/StreamPost/StreamPost.tsx